<template>
    <v-simple-table dense>
        <template v-slot:default>
            <tbody>
                <tr v-for="(mail, idx) in mails" :key="idx" @click="$router.open('/mail/showMail/' + mail.mail_encrid)">
                    <td class="td_markup"><v-icon>mdi-card-account-mail-outline</v-icon></td>
                    <td class="td_markup">{{ mail.mail_dt }}</td>
                    <td class="td_markup">{{ mail.mail_oms }}</td>
                    <td class="td_markup">{{ mail.mail_to }}</td>
                    <td class="chip_markup">
                        <v-chip :color="mail.mlrc_id" text-color="white">
                            <v-avatar left>
                                <v-icon v-if="mail.mlrc_id === 'success'">mdi-checkbox-marked-circle</v-icon>
                                <v-icon v-else>mdi-close-circle</v-icon>  
                            </v-avatar>
                            {{ mail.mlrc_dt }}
                        </v-chip>
                    </td>
                </tr>
            </tbody>
        </template>
    </v-simple-table>
</template>

<script>
    export default {    
        props: {
            mails: {
                type: Array,
                default: function() {return [];}
            },
        },
    }
</script>

<style scoped>
    .font{
        font-size: 12px !important
    }
    .td_markup {
        vertical-align: top;
        border-top: 2px solid transparent;
    }
    .chip_markup {
        vertical-align: top;
        border-top: 2px solid transparent;
        padding-bottom: 2px !important;
    }    
</style>